import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
// import { User } from 'src/app/core/models/auth.models';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-epp-service',
  templateUrl: './add-epp-service.component.html',
  styleUrls: ['./add-epp-service.component.scss']
})
export class AddEppServiceComponent implements OnInit {
  breadCrumbItems: Array<{}>;
  EPPForm: FormGroup;
  submitted = false;
  isLoading: boolean;
  keyword = 'UserName';
  currentUser: any;
  baseDocType: any;
  UserID:any;
  newdate: string;
  data: any;
  startDate: any;
  constructor(
    private fb: FormBuilder,
    private gs: GeneralService,
    private router: Router,
    private datepipe: DatePipe
  ) { 
    let a = this.router.getCurrentNavigation().extras
      if(a){
        if(a.state){
          this.UserID = a.state.Uid
          console.log("thisuserid",this.UserID)
          localStorage.setItem('id',this.UserID)
        }
      }
      if(localStorage.getItem('Uid')){
        this.UserID = localStorage.getItem('Uid')
      }
      this.breadCrumbItems = [
        { label: "EPP List", path: "/users/view-epp" },
        { label: "Add Existing EPP", path: "/", active: true },
      ];
  }
  columns = ['User Id', 'User Name', 'Group Id'];

  index = ['UserID', 'UserName', 'group_id'];

  users = [];
  ngOnInit() {
    this.newdate = new Date().toISOString().substr(0, 10);
    this.getuser()
    this.currentUser = this.gs.getcurrentUser()
    console.log('cuur',this.currentUser);
    
    this.EPPForm = this.fb.group({
      BaseDocument: new FormControl(null, Validators.required),
      StateID:new FormControl(7),
      district: new FormControl('', Validators.required),
      taluka: new FormControl(''),
      village: new FormControl(''),
      survey_number: new FormControl('', Validators.required),
      start_date: new FormControl('',[ Validators.required,Validators.pattern('\\d{4}-\\d{2}-\\d{2}')]),
      end_date: new FormControl('', [Validators.required,Validators.pattern('\\d{4}-\\d{2}-\\d{2}')]),
      user_id: new FormControl(this.UserID, Validators.required),
      group_id: new FormControl(''),
      // uname: new FormControl('', Validators.required),
      user: new FormControl(''),
      Admin_ID: new FormControl(this.currentUser.Id),
      citysurveyoffice: new FormControl(''),
      ward: new FormControl(''),
      sheetno: new FormControl(''),
      EPP_In_Days: new FormControl(30, [Validators.min(0),Validators.max(30),Validators.required]),
      // UserName: new FormControl('', Validators.required),
    },
    { validators: this.startDateBeforeEndDateValidator });
    this.startDate = this.EPPForm.controls.start_date.value
    // this.onChangeSearch($event:any)
    // this.EPPForm.controls.start_date.disable();
    // this.EPPForm.controls.end_date.disable();
  }
  startDateBeforeEndDateValidator(control: AbstractControl): ValidationErrors | null {
    const startDate = control.get('start_date').value;
    const endDate = control.get('end_date').value;

    if (startDate && endDate && startDate > endDate) {
      return { startDateAfterEndDate: true };
    }
    return null;
  }
getuser(){
  this.gs.getEppByUserId(this.UserID).subscribe((res:any)=>{
    this.data = res.data
    this.data.map((item) => {
      console.log(item);

      item.start_date = this.datepipe.transform(
        item.start_date,
        'yyyy-MM-dd'
      );
      item.end_date = this.datepipe.transform(item.end_date, 'yyyy-MM-dd');
      // item.BaseDocument.setValue(this.EPPForm.controls.BaseDocument.value)
      // this.EPPForm.controls.district.setValue('')
      // this.EPPForm.controls.taluka.setValue('')
      // this.EPPForm.controls.village.setValue('')
      // this.EPPForm.controls.citysurveyoffice.setValue('')
      // this.EPPForm.controls.ward.setValue('')
      // this.EPPForm.controls.sheetno.setValue('')
      // this.EPPForm.controls.survey_number.setValue('')
      this.EPPForm.patchValue(this.data[0])
      // item.active = item.active = 1 ? 'Active' : 'Inactive';
    });
    this.EPPForm.controls.BaseDocument.setValue(null)
     this.EPPForm.controls.district.setValue('')
      this.EPPForm.controls.taluka.setValue('')
      this.EPPForm.controls.village.setValue('')
      this.EPPForm.controls.citysurveyoffice.setValue('')
      this.EPPForm.controls.ward.setValue('')
      this.EPPForm.controls.sheetno.setValue('')
      this.EPPForm.controls.survey_number.setValue('')


  })
}
  // selectEvent(e: any) {
  //   this.EPPForm.controls['uname'].setValue(e.UserName + ' - ' + e.UserID);
  //   if (e) {
  //     this.EPPForm.controls['group_id'].setValue(e.group_id);
  //     this.EPPForm.controls['user_id'].setValue(this.UserID);
  //     this.EPPForm.controls['start_date'].setValue(this.datepipe.transform(e.start_date,'yyyy-MM-dd'));
  //     this.EPPForm.controls['end_date'].setValue(this.datepipe.transform(e.end_date,'yyyy-MM-dd'));
  //     this.EPPForm.controls['EPP_In_Days'].setValue(e.EPP_In_Days);
  //   } else {
  //     this.EPPForm.controls['group_id'].setValue('');
  //     this.EPPForm.controls['user_id'].setValue('');
  //     this.EPPForm.controls['start_date'].setValue('');
  //     this.EPPForm.controls['end_date'].setValue('');
  //     this.EPPForm.controls['EPP_In_Days'].setValue(30);
  //   }
  // }
//   onChangeSearch(e: string) {
//     this.gs.getEpp(`?UserName=${e}`).subscribe((Response: any) => {
//     this.users = Response.data;
//     if(this.UserID === Response.data.UserID){
//       this.EPPForm.controls.start_date.setValue(this.datepipe.transform(Response.data.start_date,'yyyy-MM-dd'))
//       this.EPPForm.controls.end_date.setValue(this.datepipe.transform(Response.data.end_date,'yyyy-MM-dd'))
//     }else{
//       Swal.fire({
//         title: 'Invalid',
//         text: "Internal Server Error",
//         type: "error",
//       });
//     }
//     console.log("this",this.users)
//   },
//   (error) => {                         
//     this.isLoading = false;
//     Swal.fire({
//       title: error.status,
//       text: "Internal Server Error",
//       type: "error",
//     });
    
//   });
// }
onChangeBaseDocType() {
  this.baseDocType = this.EPPForm.controls.BaseDocument.value;
  if(this.baseDocType === '0') {
    this.EPPForm.get('taluka').setValidators([Validators.required]);
    this.EPPForm.get('village').setValidators([Validators.required]);
    this.EPPForm.get('citysurveyoffice').clearValidators();
    this.EPPForm.get('ward').clearValidators();
    this.EPPForm.get('sheetno').clearValidators();
    this.EPPForm.get('taluka').updateValueAndValidity();  
    this.EPPForm.get('village').updateValueAndValidity();  
    this.EPPForm.get('citysurveyoffice').updateValueAndValidity();  
    this.EPPForm.get('ward').updateValueAndValidity();  
    this.EPPForm.get('sheetno').updateValueAndValidity();  
  } else if(this.baseDocType === '1') {
    this.EPPForm.get('citysurveyoffice').setValidators([Validators.required]);
    this.EPPForm.get('ward').setValidators([Validators.required]);
    this.EPPForm.get('sheetno').setValidators([Validators.required]);
    this.EPPForm.get('taluka').clearValidators();
    this.EPPForm.get('village').clearValidators();
    this.EPPForm.get('citysurveyoffice').updateValueAndValidity();  
    this.EPPForm.get('ward').updateValueAndValidity();  
    this.EPPForm.get('sheetno').updateValueAndValidity();  
    this.EPPForm.get('taluka').updateValueAndValidity();  
    this.EPPForm.get('village').updateValueAndValidity();  
  } 
}
datechange() {
  this.EPPForm.controls.end_date.setValue(null)
  var date = new Date(this.EPPForm.controls.start_date.value);
  this.EPPForm.controls.end_date.setValue(this.add_years(date, 1).toISOString().substr(0, 10));
}
add_years(dt,n)
{
  return new Date(dt.setFullYear(dt.getFullYear() + n));      
}
get f() {
  return this.EPPForm.controls;
}
  onSubmit(){
    if(this.baseDocType === '1' && this.EPPForm.valid) {
      this.EPPForm.controls.citysurveyoffice.setValue(this.EPPForm.controls.citysurveyoffice.value.trim());
      this.EPPForm.controls.ward.setValue(this.EPPForm.controls.ward.value.trim());
      this.EPPForm.controls.sheetno.setValue(this.EPPForm.controls.sheetno.value.trim());
    } else if(this.baseDocType === '0' && this.EPPForm.valid) {
      this.EPPForm.controls.taluka.setValue(this.EPPForm.controls.taluka.value.trim());
      this.EPPForm.controls.village.setValue(this.EPPForm.controls.village.value.trim());
      
    }
    this.EPPForm.controls.district.setValue(this.EPPForm.controls.district.value.trim());
    this.EPPForm.controls.survey_number.setValue(this.EPPForm.controls.survey_number.value.trim()); 
    // if(typeof(this.EPPForm.controls.uname.value) === 'string') {
    //   this.EPPForm.controls['user_id'].setValue(null);
    //   this.EPPForm.controls.uname.setValue(this.EPPForm.controls.uname.value.trim());
    // }
    // this.EPPForm.controls.start_date.enable();
    // this.EPPForm.controls.end_date.enable();
    this.submitted = true;

    console.log("EPP control",this.EPPForm.controls)
    
    if(this.EPPForm.valid){
      // this.EPPForm.removeControl('uname')
      this.isLoading=true;
      this.gs.addEPP(this.EPPForm.value).subscribe((res:any)=>{
        console.log("EPP Value",this.EPPForm.value)
        if(res.status === 400){
          Swal.fire({
            position: 'top-end',
            type: 'info',
            title: res.message,
            showConfirmButton: false,
            timer: 1500
          });
          this.router.navigate(['users/view-epp'])
          this.isLoading = false;
        }else{
          this.submitted = false;
          Swal.fire({
            title: 'EPP Uploaded',
            text: res.message,
            type: 'success',
            timer: 1500
          }).then(() => {
            this.submitted = false;
            // this.reFresh.emit();
            this.router.navigate(['/users/view-epp']);
          });
        }
      })
    }else{
      this.isLoading = false;
      this.submitted = true;
      Swal.fire({
        title: 'Invalid',
        text: 'Invalid Data',
        type: 'error',
      })
    }
  }
}
